import {
  AnnotationListState,
  initialAnnotationListState,
} from '../../utils/annotation-list.state.abstract';

export type PlacemarkListState = AnnotationListState;

export const initialPlacemarkListState: PlacemarkListState = {
  ...initialAnnotationListState,
};
